/****************************************************
 * Module Name:  ConsigneeDetailModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { AppBar, Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import CommonSnackbar from "../common/commonSnackBar";
import Constants from "../../utility/constants";
import Modal from "react-bootstrap/Modal";
import logo from '../../images/pansuriya.jpg'
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab"
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import MappedConsigneeDetail from "./mappedConsigneeDetail";
import UnmappedConsigneeDetail from "./unmappedConsigneeDetail";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 1 }}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
        value: index,
    };
}

const ConsigneeDetailModal = ({ handleClose, show, stoneid, fromDate, toDate, stonetype }) => {
    const [errorSnackbar, setErrorSnackbar] = useState(false);

    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <CommonSnackbar
                show={errorSnackbar}
                message={Constants.APiFailErrorMessage}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Failed"}
                handleClose={() => setErrorSnackbar(false)}
            />
            {
                <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;Consignee Details&nbsp;
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                indicatorColor="secondary"
                                textColor="inherit"
                                variant={"fullWidth"}
                                scrollButtons="auto"
                                aria-label="full width tabs example"
                                sx={{
                                    "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                                        color: "#212121",
                                        fontWeight: "bold",
                                        textAlign: 'center'
                                    },
                                    "& .MuiTab-root": {
                                        paddingBottom: 4
                                    },
                                    "& .Mui-selected": {
                                        bgcolor: "#0277bd !important",
                                        color: "#fafafa !important",
                                        fontWeight: "bold !important",
                                        paddingBottom: 4
                                    }
                                }}
                                TabIndicatorProps={{ style: { background: "#0277bd" } }}
                            >
                                {Constants.USER_PERMISSION.find(
                                    (iPermission) =>
                                        iPermission.permissionid ===
                                        Constants.PERMISSIONS.STONEDETAIL
                                ) !== undefined ?
                                    (<Tab
                                        icon={<LinkIcon />}
                                        iconPosition="start"
                                        label={"Mapped Consignees"}
                                        {...a11yProps(0)}
                                    />) : null
                                }
                                {Constants.USER_PERMISSION.find(
                                    (iPermission) =>
                                        iPermission.permissionid ===
                                        Constants.PERMISSIONS.STONE && iPermission.type === Constants.PERMISSION_TYPE[1]
                                ) !== undefined ? (
                                    <Tab
                                        icon={<LinkOffIcon />}
                                        iconPosition="start"
                                        label={"Unmapped Consignees"}
                                        {...a11yProps(1)}
                                    />
                                ) : null}
                            </Tabs>
                        </AppBar>
                        <SwipeableViews
                            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                            index={value}
                            onChangeIndex={handleChangeIndex}
                        >
                            {Constants.USER_PERMISSION.find(
                                (iPermission) => {
                                    return iPermission.permissionid ===
                                        Constants.PERMISSIONS.STONEDETAIL && iPermission.type === Constants.PERMISSION_TYPE[1];
                                }) !== undefined ? (
                                <TabPanel value={value} index={0}>
                                    <MappedConsigneeDetail
                                        stoneid={stoneid}
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        stonetype={stonetype}
                                    />
                                </TabPanel>
                            ) : (
                                <Box></Box>
                            )}
                            {Constants.USER_PERMISSION.find(
                                (iPermission) => {
                                    return iPermission.permissionid ===
                                        Constants.PERMISSIONS.STONEDETAIL_MEMO_REQUESTED && iPermission.type === Constants.PERMISSION_TYPE[1];
                                }) !== undefined ? (
                                <TabPanel value={value} index={1}>
                                    <UnmappedConsigneeDetail
                                        stoneid={stoneid}
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        stonetype={stonetype}
                                    />
                                </TabPanel>
                            ) : (
                                <Box></Box>
                            )}
                        </SwipeableViews>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="contained" color="error" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    )
}

export default ConsigneeDetailModal;